export default __webpack_public_path__ + "static/media/Ben_BIO_Image.f6c87680.jpg";